import BodyView from "@/layout/BodyView.vue";
import User from "@/pages/setting/user/Index.vue";
import Role from "@/pages/setting/role/Index.vue";
import Menu from "@/pages/setting/menu/Index.vue";
import Permission from "@/pages/setting/permission/Index.vue";
import Template from "@/pages/setting/template/Index.vue";
import Design from "@/pages/setting/template/Design.vue";
import Clinic from "@/pages/setting/clinic/Index.vue";

export const route = 

{
  path: "/setting",
  component: BodyView,
  children: [
    {
      path: "user",
      name: "user",
      component: User,
      meta: {
        title: 'User Management | INDOFORCETECH',
      }
    },
    {
      path: "clinic",
      name: "clinic",
      component: Clinic,
      meta: {
        title: 'Clinic Management | INDOFORCETECH',
      }
    },
    {
      path: "role",
      name: "role",
      component: Role,
      meta: {
        title: 'Role Management | INDOFORCETECH',
      }
    },
    {
      path: "menu",
      name: "menu",
      component: Menu,
      meta: {
        title: 'Menu Management | INDOFORCETECH',
      }
    },
    {
      path: "permission",
      name: "permission",
      component: Permission,
      meta: {
        title: 'Permission Management | INDOFORCETECH',
      }
    },
    {
      path: "template",
      name: "template",
      meta: {
        title: 'Template Management | INDOFORCETECH',
      },
      children: [
        {
          path: "",
          name: "template-list",
          component: Template,
        },
        {
          path: "add",
          name: "template-add",
          component: Design,
        },
        {
          path: ":id/edit",
          name: "template-edit",
          component: Design,
        }
      ]
    }
  ]
}